import {
  handleCatchErrors,
  responseDataFormat,
} from "../../../middlewares/resolveRequests";
import {
  addProcedureService,
  addSubTaskCommentService,
  addSubTaskProcedureService,
  deleteProc,
  editProc,
  editProcStatus,
  getProcedure,
  getSubTaskProcedureForm,
  getTaskMembers,
} from "../../../services/procedure/procedure";

export const addProcedure = async (taskId, data, token) => {
  let response;
  try {
    response = await addProcedureService(taskId, data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

// add sub task comment
export const addSubTaskComment = async (taskprocedureId, data, token) => {
  let response;
  try {
    response = await addSubTaskCommentService(taskprocedureId, data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const addSubTaskProcedure = async (taskId, data, token) => {
  let response;
  try {
    response = await addSubTaskProcedureService(taskId, data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getAllMemberInTask = async (taskId, token) => {
  let response;
  try {
    response = await getTaskMembers(taskId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const procData = async (procId, token) => {
  let response;
  try {
    response = await getProcedure(procId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const subProcData = async (procId, token) => {
  let response;
  try {
    response = await getSubTaskProcedureForm(procId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const editProcData = async (data = {}, isActivityProc, token) => {
  let response;
  try {
    response = await editProc(data, isActivityProc, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const updateProcStatus = async (procId, statusId, token) => {
  let response;
  try {
    response = await editProcStatus(procId, statusId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const deleteProcedure = async (procId, token) => {
  let response;
  try {
    response = await deleteProc(procId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  }
};
